/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const headerActionsAuthenticatedStyle = {
  listItem: (theme: Theme) => ({ color: theme.palette.primary.main }),
};
